import SaveButton from "../ScenarioTypeEditor/SaveButton"

const ScenarioEditorLayout = ({label, haveChanges, saveHandler, children}) => {
    return (
        <>
            <SaveButton
                label={label}
                haveChanges={haveChanges}
                clickHandler={saveHandler}
            />
            <div className="scenario-form-wrapper">
                <div className="scenario-form">
                    {children}
                </div>
            </div>
            <SaveButton
                label={label}
                haveChanges={haveChanges}
                clickHandler={saveHandler}
            />
        </>
    )
}

export default ScenarioEditorLayout